import React from 'react';
import styles from './image-preview.module.css';

import { NativeTypes } from 'react-dnd-html5-backend'
import { useDrop, DropTargetMonitor } from 'react-dnd'

const ImagePreview = (props) => {

  const [{ canDrop, isOver }, drop] = useDrop(
    () => ({
      accept: [NativeTypes.FILE],
      drop(item: { files: any[] }) {
        if (props.onDrop) {
          props.onDrop(item)
        }
      },
      collect: (monitor: DropTargetMonitor) => ({
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      }),
    }),
    [props],
  )

  const maxFiles = props.maxFiles;
  const singleFileDragMessage = 'Arraste e solte para adicionar uma imagem';
  const multiFileDragMessage = 'Arraste e solte suas imagens';

  const fileDragMessage = maxFiles > 1 ? multiFileDragMessage : singleFileDragMessage;

  const isActive = canDrop && isOver
  const dragMessage = isActive ? "Solte suas imagens" : fileDragMessage

  const handleButtonClick = () => {
    document.getElementById(`file-${maxFiles}`)?.click();
  };

  const dragElement = isActive ? <p>{dragMessage}</p> :
    <div className={styles.emptyStateContainer}>
      <p className={styles.dragMessage}>{dragMessage}</p>
      {props.isUploading ? (
        <p className={styles.uploadProgress}>{props.uploadProgress}</p>
      ) : (
        <button
          type="button"
          className={styles.uploadButton}
          onClick={handleButtonClick}
          disabled={props.isUploading}
        >
          {maxFiles > 1 ? 'Selecionar Imagens' : 'Selecionar Imagem'}
        </button>
      )}
    </div>;

  let containerClasses = styles.dragArea;
  const isEmpty = !props.imageList || props.imageList.length === 0
  const showOverlay = isEmpty || isActive;
  if (showOverlay) {
    containerClasses += ` ${styles.empty}`
  } else {
    containerClasses += ` ${styles.nonEmpty}`
  }

  if (props.thumbnailClassName) {
    containerClasses += ` ${styles.dragAreaNoPadding}`
  }

  const handleFile = (file) => (ref) => {
    if (ref) {
      ref.src = file.location
    }
  }

  return (
    <div ref={drop as any} className={containerClasses}>
      <input id={`file-${maxFiles}`}
        type='file'
        className={styles.linkInput}
        accept='.jpeg, .jpg, .png'
        onChange={(e) => props.onDrop(e.target)}
        multiple={maxFiles > 1}
      />
      {showOverlay ? dragElement
        : (
          <>
            <div className={styles.previewContainer}>
              {props.imageList.map((image) => {
                return (
                  <div key={image.id} className={styles.thumbnailContainer}>
                    <button className={styles.thumbnailDeleteButton} type='button' onClick={() => props.onDelete(image.id)}>X</button>
                    <img className={props.thumbnailClassName ?? styles.thumbnail} ref={handleFile(image)} alt={image.originalName} />
                  </div>)
              })}
            </div>
            <div className={styles.addMoreContainer}>
              {props.isUploading ? (
                <p className={styles.uploadProgress}>{props.uploadProgress}</p>
              ) : (
                <button
                  type="button"
                  className={styles.addMoreButton}
                  onClick={handleButtonClick}
                  disabled={props.isUploading}
                >
                 Adicionar imagens
                </button>
              )}
            </div>
          </>
        )}
    </div>
  )
}
export default ImagePreview;